export default __webpack_public_path__ + "a5cb54cf3bb10803c6a567f434f3c8a9.png";